<template>
  <div class="credits interventions">
    <section class="headtop fixed-headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>Interventions</h1>
          <br>
          <RunButtons :key="'runbuttons_' + currentRun.getCurrentStep()" />
        </div>
        <div class="col-sm-3">
          Credits left: {{ totalCredits - creditsUsed - creditsUsedBeforeGettingHere }} <br><br>
          <CreditsProgressBar :progress-value="creditsUsed + creditsUsedBeforeGettingHere" />
        </div>
        <div class="clearfix" />
      </div>
    </section>

    <div class="first-container container lessons">
      <div class="row">
        <div class="text-body col-sm-12">
          <p>
            Your task is to decide how you would like to improve the MCSim region, and to make
            choices about future investment to help do it.
          </p>
          <p>
            You can choose what to invest in from the menu below. Each item has a ‘cost’, in
            credits, and you have a total budget of 100 credits to spend however and whenever
            you like.
          </p>
          <p>
            MCSim simulates ten years, and you’ll no doubt quickly realise that to achieve
            the maximum impact you should make changes as early as possible. So you can
            experiment with the effect the interventions have you can turn them on and off as
            the simulation runs, although you may find that turning them off also has a cost,
            in credits. You can use what you’ve learnt and apply your expertise in your final
            run which you can then submit to Midlands Connect.
          </p>
          <p>
            <a
              href
              @click.prevent="displayModelInfoModal()"
            >Which interventions are right for me?</a>
          </p>
          <div class="clearfix" />
        </div>
      </div>
    </div>

    <div class="container">
      <section class="widget policies-container">
        <form class="form-inline">
          <div class="row inputs-container">
            <div class="table-row">
              <div class="col-xs-6 no-float" />
              <div class="col-xs-3 text-center top no-float">
                <h4>Previous step</h4>
                <div class="history">
                  <router-link to="/interventions-history">
                    History
                  </router-link>
                </div>
              </div>
              <div class="col-xs-3 white-background text-center top no-float currentRun">
                <h4>Next step</h4>
                <p>
                  Use these tick boxes to turn on actions to improve conditions.
                  Any changes you already made will appear here.
                </p>
              </div>
              <div class="clearfix" />
            </div>
          </div>

          <template v-for="cat in inputCategories">
            <div
              :key="'interventions_cat_' + cat.reference"
              class="row inputs-container"
            >
              <div class="table-row white-background">
                <div class="form-group col-xs-6 text-left no-float">
                  <h3>{{ cat.name }}</h3>
                </div>

                <div
                  class="form-group
                  col-xs-3
                  no-float
                  text-center"
                />
                <div
                  class="form-group
                  col-xs-3
                  no-float
                  text-center
                  currentRun"
                />

                <div class="clearfix" />
              </div>
            </div>

            <template v-for="(input, index) in inputsForCategory(cat.reference)">
              <div
                :key="cat.name + '-' + input.label"
                :class="
                  'row inputs-container white-background ' +
                    (index % 2 === 1 ? '' : 'striped')
                "
              >
                <div class="table-row">
                  <div class="form-group col-xs-6 text-left no-float">
                    <label
                      for="exampleInputName2"
                      class="control-label"
                    >
                      {{ input.label }}
                      <span
                        class="info-badge badge"
                        data-toggle="popover"
                        data-trigger="hover"
                        data-container="body"
                        data-placement="right"
                        :data-title="null"
                        :data-content="input.description"
                      >i</span>
                    </label>
                    <p class="muted">
                      <small>
                        Credit: {{ input.credit }}
                        <template v-if="input.oneoff">- this policy can only be implemented once.</template>
                      </small>
                    </p>
                  </div>

                  <div
                    class="form-group
                    col-xs-3
                      no-float
                    text-center"
                  >
                    <input
                      type="checkbox"
                      :checked="
                        input.values[`time${currentRun.getCurrentStep() - 1}`]
                      "
                      disabled="true"
                      @click="changeInputValue(input)"
                    >
                  </div>
                  <div
                    class="form-group
                    col-xs-3
                      no-float
                    text-center currentRun"
                  >
                    <template v-if="!input.oneoff">
                      <input
                        type="checkbox"
                        :checked="
                          input.values[`time${currentRun.getCurrentStep()}`]
                        "
                        :disabled="!isInputValueEnabled(input)"
                        @click="changeInputValue(input)"
                      >
                    </template>
                  </div>

                  <div class="clearfix" />
                </div>
              </div>
            </template>
          </template>

          <div class="row inputs-container">
            <div class="table-row">
              <div class="col-xs-6 no-float" />
              <div class="col-xs-3 text-center bottom no-float" />
              <div class="col-xs-3 white-background text-center bottom no-float currentRun" />
              <div class="clearfix" />
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import CreditsProgressBar from "../components/CreditsProgressBar";
import RunButtons from "../components/RunButtons";

import data from "../services/data";
import * as $ from "jquery";
import "bootstrap";

export default {
  components: {
    CreditsProgressBar,
    RunButtons,
  },
  data() {
    return {
      inputs: [],
      inputCategories: data.inputCategories,
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      runStages: data.runStages,
      maxNumberOfRuns: data.maxNumberOfRuns,
      totalCredits: data.totalCredits,
      creditsUsedBeforeGettingHere: 0,
      creditsUsed: 0,
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.setupInputVariables();
    this.creditsUsedBeforeGettingHere = this.currentRun.getCreditsSpent();
    this.countCredits();
  },
  mounted() {
    $(document).ready(function () {
      $(".info-badge").each(function () {
        $(this).popover();
      });
    });
  },
  methods: {
    // If this is the first run and the input variables are not
    // loaded yet, let's copy the default values from the data
    // const.
    setupInputVariables() {
      var inputVariables = this.currentRun.getInputVariables();
      if (!inputVariables || inputVariables.length === 0) {
        inputVariables = [];

        for (var d of data.inputs) {
          const values = {};
          for (var i = 1; i <= this.maxNumberOfRuns; i++) {
            values[`time${i}`] = false;
          }

          const input = {
            label: d.label,
            credit: d.credit,
            description: d.description,
            reference: d.reference,
            oneoff: d.oneoff,
            switches: d.switches,
            values,
            modelVariable: d.modelVariable,
            category: d.category,
          };

          inputVariables.push(input);
        }

        this.currentRun.setInputVariables(inputVariables);
      }
      this.inputs = this.currentRun.getInputVariables();
    },
    modifySwitches(checked, switches) {
      for (const s of switches) {
        if (s.if === checked) {
          const variable = this.getVariableFromInputName(s.otherVariable);
          if (variable) {
            if (s.action === "DISABLE") {
              this.disableInputValue(variable);
            } else if (s.action === "ENABLE") {
              this.enableInputValue(variable);
            } else if (s.action === "CHECK") {
              this.changeInputValue(variable, "CHECK", false);
            } else if (s.action === "UNCHECK") {
              this.changeInputValue(variable, "UNCHECK", false);
            }
          }
        }
      }
    },
    getVariableFromInputName(variableName) {
      for (const variable of this.inputs) {
        if (variable.modelVariable === variableName) {
          return variable;
        }
      }
    },
    disableInputValue(variable) {
      variable.disabled = true;
    },
    enableInputValue(variable) {
      variable.disabled = false;
    },
    changeInputValue(variable, checkOverride, dontFollowSwitches) {
      const runIndex = this.currentRun.getCurrentStep();
      let checked = !variable.values[`time${runIndex}`];

      if (checkOverride === "CHECK") {
        checked = true;
      }
      if (checkOverride === "UNCHECK") {
        checked = false;
      }

      variable.values[`time${runIndex}`] = checked;

      //
      // When one of the input variables change for this year, we have
      // to copy this variable for each further iteration as well.
      // This to keep what happens in the model aligned with the user
      // experience.
      //
      for (let i = runIndex; i <= this.maxNumberOfRuns; i++) {
        variable.values[`time${i}`] = checked;
      }

      if (dontFollowSwitches !== false && variable.switches) {
        this.modifySwitches(checked, variable.switches);
      }

      this.countCredits();
    },
    isInputValueEnabled(input) {
      if (input.oneoff) {
        return false;
      }
      if (input.disabled) {
        return false;
      }
      if (this.currentRun.getCurrentStep() == this.maxNumberOfRuns) {
        return false;
      }

      const runIndex = this.currentRun.getCurrentStep();
      const changedValue = !input.values[`time${runIndex}`];

      const override = {
        modelVariable: input.modelVariable,
        value: changedValue,
      };

      const creditsAfterChange = this.countCredits(override);
      const creditsUsedAfterChange =
        this.totalCredits -
        this.creditsUsedBeforeGettingHere -
        creditsAfterChange;

      if (creditsUsedAfterChange < 0) {
        return false;
      }

      return true;
    },
    /**
     * For display only: we display inputs grouped by their category.
     * This is a helper function to return all inputs that belong to
     * a specific group.
     */
    inputsForCategory(categoryName) {
      if (!categoryName) {
        return this.inputs;
      }
      return this.inputs.filter((e) => e.category === categoryName);
    },
    countCredits(override) {
      const runIndex = this.currentRun.getCurrentStep();
      const previousIndex = Math.max(0, runIndex - 1);

      let credits = 0;
      for (const input of this.inputs) {
        const previousValue =
          previousIndex === runIndex
            ? false
            : input.values[`time${previousIndex}`];
        let currentValue = !!input.values[`time${runIndex}`];

        if (override && override.modelVariable === input.modelVariable) {
          currentValue = override.value;
        }

        if (previousValue !== currentValue) {
          // We don't deduct credits if you switch them off now
          if (currentValue) {
            credits += input.credit;
          }
        }
      }

      if (override && override.modelVariable) {
        return credits;
      }

      this.currentRun.setCreditsSpent(
        this.creditsUsedBeforeGettingHere + credits
      );

      this.creditsUsed = credits;
    },
    displayModelInfoModal() {
      this.$root.$data.eventHub.$emit("show-modelinfo-modal");
    },
  },
};
</script>

<style lang="scss">
.interventions .first-container {
  padding-top: 330px;
}
.headtext {
  margin: -22px 0 30px 0;
  padding: 15px 0;
  background: #efefef;
}
.currentRun {
  border-width: 0 2px;
  border-style: solid;
  border-color: #009482;
}
.top.currentRun {
  border-width: 2px 2px 0 2px;
}
.top .history {
  font-weight: bold;
  font-size: 0.8em;
  padding-bottom: 10px;
  margin-top: -12px;
}
.top h4 {
  padding-bottom: 8px;
}
.top p {
  font-size: 0.95em;
}
.top {
  padding-top: 25px;
  padding-bottom: 18px;
  font-weight: 400;
  font-size: 14px;
}
.widget.policies-container {
  background: none;
}
.widget.policies-container .white-background,
.widget.policies-container .white-background-ifcurrent.currentRun {
  background-color: #fff;
}
.inputs-container {
  display: table;
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  .table-row .no-float {
    padding: 6px 18px;
  }
}
.striped .table-row {
  background: #f9f9f9;
}
</style>
